// extracted by mini-css-extract-plugin
export default {"home-page":"HomePage_home-page__K1wu-"};